import { render, staticRenderFns } from "./commonList.vue?vue&type=template&id=44831dd6&scoped=true"
import script from "./commonList.vue?vue&type=script&lang=js"
export * from "./commonList.vue?vue&type=script&lang=js"
import style0 from "./commonList.vue?vue&type=style&index=0&id=44831dd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44831dd6",
  null
  
)

export default component.exports